import React, { Component } from 'react';
import { Header } from './header.js';
import { Footer } from './footer.js';
import { CategorySelectorList } from './category-selector-rewrite';
import * as util from './util';
import { logBusinessActivities } from './business_activities';

import ResearchSoftwareMinimalDatePicker from './researchSoftwareMinimalDatePicker';
import { TextInfo, TextLine, TextField, Price, ConfirmedText, Tags,
         ComplexityRate, CheckBox, AGBCheckBox, SubmitButton, IntegerField, MultipleFileUpload} from './common-form-components.js';

import './researchsoftware.css';

var introductoryText = '<p>Der Marktplatz der Ayacandas bietet die Möglichkeit, Produkte jeglicher Art aus dem Bereich Forschung und Lehre einfach zum Kauf anbieten zu können.<p>Wenn sie Software anbieten wollen, ist es nicht notwendig, den zugehörigen Code offenzulegen. (auch wenn dies erwünscht ist). Die Verpflichtung reduziert sich darauf, den Code zu beschreiben und seine Eigenschaften gründlich getestet zu haben.</p> <p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>'

var complexityRate = [
  <option key='0'>bitte wählen...</option>,
  <option key='1'>1 - niedrige Komplexität</option>,
  <option key='2'>2 - </option>,
  <option key='3'>3 - </option>,
  <option key='4'>4 - </option>,
  <option key='5'>5 - mittlere Komplexität</option>,
  <option key='6'>6 - </option>,
  <option key='7'>7 - </option>,
  <option key='8'>8 - </option>,
  <option key='9'>9 - </option>,
  <option key='10'>10 - hohe Komplexität</option>];

var satisfactionRate = [
  <option key='0'>bitte wählen...</option>,
  <option key='1'>Sehr zufrieden</option>,
  <option key='2'>Zufrieden</option>,
  <option key='3'>Weniger zufrieden</option>,
  <option key='4'>Unzufrieden</option>,
];

let faqResearchsoftware = [
  {
    content: "Ein Weiterverkauf innerhalb der meisten Förderprogramme ist unproblematisch, da er den Förderzweck nicht entfremdet. Ein Weiterverkauf verstößt somit <u>nicht</u> gegen die Bedingungen des Förderbescheids. Eine Mehrwerterschaffung sollte jedoch von der jeweiligen  Klinik an das zuständige Ministerium gemeldet werden.<br /><br />Das Anbieten ist unkritisch, sofern vom ursprünglichen Förderbescheid kein Geld entwendet oder veräußert wird und nicht gegen die Begutachtungslinie der DFG gehandelt wird. In diesem Zusammenhang darf nur Eigenleistung verkauft werden.",
    title: "Gibt es Probleme, wenn das Produkt mit der Hilfe von Förderbescheiden entwickelt wurde?",
    key: 0
  },
  {
    content: "Einnahmen gehen, falls Sie nicht als Privatperson verkaufen, oft nicht an Sie, sondern an die Institution, in deren Namen Sie verkaufen. Solche Einnahmen können Sie Sich im Rahmen des Controllings als eigene Einnahmen durch Verrechnung gutschreiben lassen. ",
    title: "Was habe ich davon, wenn ich für meine Institution etwas verkaufe?",
    key: 1
  },
  {
    content: "Wenn Sie als nicht-kommerzieller Nutzer ein Produkt anbieten, wird Ayacandas wesentliche Punkte für Sie übernehmen.",
    title: "Was ist mit dem Thema Haftung und Gewährleistung beim Einstellen von Produkten?",
    key: 2
  },
  {
    content: "Außer bei Herstellern und Dienstleistern erfolgt die Kommunikation über die Foren auf Ayacandas.com ohne Aufdeckung Ihrer Identität.",
    title: "Warum darf man in den Foren seine Anonymität nicht aufdecken?",
    key: 3
  },
];

export class CreateResearchSoftware extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.fetchDataAndRedirect();
  }

  fetchDataAndRedirect() {
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/create-researchsoftware`;
    var promise = fetch(url, {method: 'POST',
                              headers: headers,
                              body: ''
    })
      .then(response => response.json())
      .catch(function(exception) {
        alert('Konnte keine neue Software für Forschung und Lehre anlegen!');
        console.error(`Could not create new researchsoftware!`, exception);
      });
    promise.then(function(json) {
      self.props.history.replace(`/update-researchsoftware/${json.id}`);
    });
  }

  render() {
    return(
      <div className="CreateResearchsoftware">
      </div>
    )
  }
}

export class UpdateResearchSoftware extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.update = this.update.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.isValid = this.isValid.bind(this);
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
    this.save = this.save.bind(this);

    this.state = {
      startID: 2,
      id: null,
      name: '',
      desc: '',
      categories: '',
      price: 0,
      researchtype: '',
      aim: '',
      functionality: '',
      specialties: '',
      target: '',
      usage: '',
      tags: '',
      standalone_sw: '',
      is_standalone_sw: '',
      agreement: false,
      direct_database_access: null,
      direct_database_access_desc: '',
      has_additional_interface: null,
      additional_interface: '',
      has_additional_licence: null,
      additional_licence: '',
      data_component_complete: '',
      data_component_options: '',
      data_manipulation: '',
      data_manipulation_protocol: '',
      manipulation_authorised: null,
      manipulation_authorised_desc: '',
      data_update_interval: 0,
      has_update_side_effect: '',
      update_side_effect: '',
      has_release_plan: '',
      release_plan: '',
      is_preparation_needed: '',
      preparation_needed: '',
      has_customer_reference: '',
      customer_reference: '',
      successful_deployment: null,
      successful_deployment_description: '',
      clinic_desc: '',
      clinic_number: 0,
      user_number: 0,
      complexity_rate: 0,
      date: '',
      satisfaction_rate: 0,
      rating_desc: '',
      pdf_files: ',,,,',
      image_files: ',,,,,,,,,',
      video_files: '',
      product_files: '',
      agb_agreement: false,
    };

    this.fetchDataAndRedirect();
    this.globalFormData = {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    if( nextState !== this.state) {
      return true;
    } else {
      return false;
    }
  }

  update(slot, value) {
    this.globalFormData[slot]=value;
  }

  fetchDataAndRedirect() {
    var id = this.props.match.params.id;
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/create-researchsoftware`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: `id=${id}`
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Werte laden!');
        console.error(`Could not retrieve researchsoftware data!`, exception);
      });
    promise.then(function (json) {
      self.setState({
        id: json.id,
        name: json.name,
        desc: json.desc,
        categories: json.categories,
        price: json.price,
        researchtype: json.researchtype,
        aim: json.aim,
        functionality: json.functionality,
        specialties: json.specialties,
        target: json.target,
        usage: json.usage,
        tags: json.tags,
        is_standalone_sw: json.is_standalone_sw,
        standalone_sw: json.standalone_sw,
        direct_database_access: json.direct_database_access,
        direct_database_access_desc: json.direct_database_access_desc,
        has_additional_interface: json.has_additional_interface,
        additional_interface: json.additional_interface,
        has_additional_licence: json.has_additional_licence,
        additional_licence: json.additional_licence,
        data_component_complete: json.data_component_complete,
        data_component_options: json.data_component_options,
        data_manipulation: json.data_manipulation,
        data_manipulation_protocol: json.data_manipulation_protocol,
        manipulation_authorised: json.manipulation_authorised,
        manipulation_authorised_desc: json.manipulation_authorised_desc,
        data_update_interval: json.data_update_interval,
        has_update_side_effect: json.has_update_side_effect,
        update_side_effect: json.update_side_effect,
        has_release_plan: json.has_release_plan,
        release_plan: json.release_plan,
        is_preparation_needed: json.is_preparation_needed,
        preparation_needed: json.preparation_needed,
        has_customer_reference: json.has_customer_reference,
        customer_reference: json.customer_reference,
        successful_deployment: json.successful_deployment,
        successful_deployment_description: json.successful_deployment_description,
        clinic_desc: json.clinic_desc,
        clinic_number: json.clinic_number,
        user_number: json.user_number,
        complexity_rate: json.complexity_rate,
        date: json.date,
        satisfaction_rate: json.satisfaction_rate,
        rating_desc: json.rating_desc,
        pdf_files: json.pdf_files,
        image_files: json.image_files,
        video_files: json.video_files,
        product_files: json.product_files,
        agreement: json.agreement,
        agb_agreement: json.agb_agreement,
      });
    })
  }

  isValid(categories) {

    if (categories === undefined)
      return false;

    if (categories === null)
      return false;

    if (categories === "")
      return false;

    if (typeof categories === 'string') {
      categories = categories.split(/,/);
    }

    var catInput = categories.map(item => parseInt(item, 10));
    for (var i = 0; i < categories.length; i++) {
      if (parseInt(catInput[i], 10) === catInput[i]) {
        return true;
      }
    }
    return false;
  }

  validateInput() {
    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length > 200) {
        alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
      if (this.globalFormData['name'].length > 200) {
        alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");
        return false;
      }
    }

    if (this.globalFormData['desc'] === undefined) {
      if (this.state.desc.length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
      if (this.state.desc.length > 2000) {
        alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['desc'].length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
      if (this.globalFormData['desc'].length > 2000) {
        alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");
        return false;
      }
    }
    return true;
  }

  checkRequiredFields() {
    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
    }

    if ((this.globalFormData['categories'] === undefined) && (!this.isValid(this.state.categories))) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }
    if (!this.isValid(this.globalFormData['categories'])) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }

    if (this.globalFormData['desc'] === undefined) {
      if (this.state.desc.length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
    } else {
      if (this.globalFormData['desc'].length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
    }

    if (this.globalFormData['price'] === undefined) {
      if (this.state.price.length === 0) {
        alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");
        return false;
      }
    } else {
      if (this.globalFormData['price'].length === 0) {
        alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");
        return false;
      }
    }

    if (this.globalFormData['agreement'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }

    if (this.globalFormData['agreement'] === undefined) {
      if (this.state.agreement !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agb_agreement'] === false) {
      alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
      return false;
    }

    if (this.globalFormData['agb_agreement'] === undefined) {
      if (this.state.agb_agreement !== true) {
        alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
        return false;
      }
    }

    return true;
  }

  save(announce) {
    if (announce === true) {
      if (this.checkRequiredFields() === false) {
        return;
      }
    }

    if (announce === true) {
      if (this.validateInput() === false) {
        return;
      }
    }
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    var formData = new FormData();
    Object.keys(this.globalFormData).map( key => formData.append(key, self.globalFormData[key]));
    formData.append("id", this.state.id);
    if(announce === true) {
      formData.append('announce', true);
    } else {
      formData.append('announce', false);
    }
    formData.append('active', true);
    var url = `/api/update-researchsoftware`;
    var promise = fetch(url, {method: 'POST',
                              headers: headers,
                              body: formData
                             })
        .then(response => response.json())
        .catch(function(exception) {
          alert('Konnte keine Werte speichern!');
          console.error(`Could not save researchsoftware data!`, exception);
        });
    promise.then(function (json) {
      alert('Werte wurden gespeichert.');
      if(announce === true) {
        logBusinessActivities("Software fuer Forschung und Lehre wurde gespeichert, allem zugestimmt und veroeffentlicht.", json.id, json.categories, json.price);
      }
      self.globalFormData = {};
      self.setState({
        id: json.id,
        name: json.name,
        desc: json.desc,
        categories: json.categories,
        price: json.price,
        researchtype: json.researchtype,
        aim: json.aim,
        functionality: json.functionality,
        specialties: json.specialties,
        target: json.target,
        usage: json.usage,
        tags: json.tags,
        is_standalone_sw: json.is_standalone_sw,
        standalone_sw: json.standalone_sw,
        direct_database_access: json.direct_database_access,
        direct_database_access_desc: json.direct_database_access_desc,
        has_additional_interface: json.has_additional_interface,
        additional_interface: json.additional_interface,
        has_additional_licence: json.has_additional_licence,
        additional_licence: json.additional_licence,
        data_component_complete: json.data_component_complete,
        data_component_options: json.data_component_options,
        data_manipulation: json.data_manipulation,
        data_manipulation_protocol: json.data_manipulation_protocol,
        data_update_interval: json.data_update_interval,
        has_update_side_effect: json.has_update_side_effect,
        update_side_effect: json.update_side_effect,
        has_release_plan: json.has_release_plan,
        release_plan: json.release_plan,
        is_preparation_needed: json.is_preparation_needed,
        preparation_needed: json.preparation_needed,
        has_customer_reference: json.has_customer_reference,
        customer_reference: json.customer_reference,
        successful_deployment: json.successful_deployment,
        successful_deployment_description: json.successful_deployment_description,
        clinic_desc: json.clinic_desc,
        clinic_number: json.clinic_number,
        user_number: json.user_number,
        complexity_rate: json.complexity_rate,
        date: json.date,
        satisfaction_rate: json.satisfaction_rate,
        rating_desc: json.rating_desc,
        pdf_files: json.pdf_files,
        image_files: json.image_files,
        video_files: json.video_files,
        product_files: json.product_files,
        agreement: json.agreement,
        agb_agreement: json.agb_agreement
      });
      self.props.history.push('/product-list');
    })
  }

  render() {
    return (
        <div>
        {util.isNonCommercialUser() &&
          <div className="Landing" id="contentId">
           <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
           <div className="ContentWithBackground">
             <div className="content" id="content">
               <div className="productHeader1"  id="toplanding">
               Software für Forschung und Lehre einstellen
               </div>
               <div className="productHeader2">
                 Nach abgeschlossener Einstellung Ihres Angebotes bleibt
                 dieses für ein Jahr auf der Ayacandas.com zum angegebenen
                 Preis auffindbar.
                 <TextInfo content={introductoryText} />
                 </div>
         <div className="productForm1  marginTop30">
         <div className="prodInputComp">
         <TextLine heading=" Was bieten Sie an?" subheading="Unter diesem Titel wird ihr Produkt angezeigt." obligatory={true} maxLength='200' value={this.state.name} placeholder="was bieten Sie an" slot='name' update={this.update} />
         <TextField heading="Beschreibung" obligatory={true} placeholder="Beschreibung"  value={this.state.desc} slot='desc' update={this.update} />
         <CategorySelectorList value={this.state.categories} slot="categories" update={this.update} categoryLimit={6} />
         <Price heading="Preis in Euro"
         subheading="85% des Netto-Preises, den Ayacandas durch den Weiterverkauf Ihres Produktes erzielt, wird Ihnen oder Ihrer Institution für das Zurverfügungstellen der Lizenz ausbezahlt." obligatory={true} maxLength='9' value={this.state.price} slot='price' update={this.update} />
         <TextLine heading="Typ der Software?" maxLength='100' value={this.state.researchtype} placeholder="Typ der Software" slot='researchtype' update={this.update} />
         <TextField heading="Wofür wurde die Software geschrieben?" placeholder="Zweck der Software" value={this.state.aim} slot='aim' update={this.update} />
         <TextField heading="Nennen Sie bitte eventuelle Besonderheiten der Software." placeholder="Besonderheiten der Software" value={this.state.functionality} slot='functionality' update={this.update} />
         <TextField heading="Bitte beschreiben Sie die Funktionen Ihrer Software." placeholder="Funktionsbeschreibung" value={this.state.specialties} slot='specialties' update={this.update} />
         <TextField heading="Welche ist die Zielgruppe der Software?" placeholder="Zielgruppe der Software" value={this.state.target} slot='target' update={this.update} />
         <TextField heading="Wo wurde die Software bereits verwendet?" placeholder="bisherige Verwendungen der Software" value={this.state.usage} slot='usage' update={this.update} />
         <ConfirmedText heading="Ist die Software ein eigenständiges Produkt (d.h sie ist kein Add-On) ?" placeholder="Beschreibung" value={this.state.is_standalone_sw} value2={this.state.standalone_sw} slot='is_standalone_sw' slot2='standalone_sw' update={this.update} />
         <Tags heading="Stichworte, um gefunden zu werden (max. 7, durch Komma getrennt)" placeholder="Tags/Stichworte" value={this.state.tags} slot='tags' update={this.update} match={this.props.match} maxTags={7} maxLength={150}  />
         <MultipleFileUpload heading="Anhang: Dokumente, vorzugsweise als PDF-Datei (bitte nur fachliches Material)" value={this.state.pdf_files} slot="pdf_files" update={this.update}  />
         <MultipleFileUpload heading="Anhang: Beschreibende Bilder oder Screenshots" value={this.state.image_files} slot="image_files" update={this.update}  />
         <MultipleFileUpload heading="Anhang: Video, max. 5 GB" value={this.state.video_files} slot="video_files" update={this.update}  />
         <ConfirmedText heading="Braucht die Software einen direkten Zugriff auf die Datenbank? Wenn ja, beschreiben Sie die Zugriffsart." placeholder="Beschreibung" value={this.state.direct_database_access} value2={this.state.direct_database_access_desc} slot='direct_database_access' slot2='direct_database_access_desc' update={this.update} />
         <ConfirmedText heading="Werden zusätzliche Schnittstellen benötigt?" placeholder="Beschreibung" value={this.state.has_additional_interface} value2={this.state.additional_interface} slot='has_additional_interface' slot2='additional_interface' update={this.update} />
         <ConfirmedText heading="Werden zusätzliche Lizenzen benötigt?" placeholder="Beschreibung" value={this.state.has_additional_licence} value2={this.state.additional_licence} slot='has_additional_licence' slot2='additional_licence'  update={this.update} />
         <ConfirmedText heading="Werden alle Elemente für den Datenzugriff mitgeliefert? Welche Möglichkeiten bieten Sie an?" placeholder="Beschreibung" value={this.state.data_component_complete} value2={this.state.data_component_options} slot='data_component_complete' slot2='data_component_options' update={this.update} />
         <ConfirmedText heading="Werden Daten am Quellsystem manipuliert oder verändert? Falls ja: Wie wird dies protokolliert?" placeholder="Beschreibung" value={this.state.data_manipulation} value2={this.state.data_manipulation_protocol} slot='data_manipulation' slot2='data_manipulation_protocol' update={this.update} />
         <ConfirmedText heading="Erfolgt der Zugriff auf die Datenquelle über vom Hersteller autorisierte Zugriffsmethoden?" placeholder="Beschreibung" value={this.state.manipulation_authorised} value2={this.state.manipulation_authorised_desc} slot='manipulation_authorised' slot2='manipulation_authorised_desc' update={this.update} />
         <IntegerField heading="Falls eine synchrone Schnittstelle aktiv ist: Wie hoch ist das Aktualisierungsintervall in Minuten?" maxLength='6' value={this.state.data_update_interval} placeholder="Aktualisierungsintervall in Min." slot='data_update_interval' update={this.update} />
         <ConfirmedText heading="Falls eine „synchrone Schnittstelle“ aktiv ist: Gibt es Aktualisierungsnebenwirkungen? (Wenn ja, welche?)" placeholder="Beschreibung" value={this.state.has_update_side_effect} value2={this.state.update_side_effect} slot='has_update_side_effect' slot2='update_side_effect' update={this.update} />
         <ConfirmedText heading="Gibt es einen Release-Plan oder geplante Weiterentwicklungen? Falls ja, bitte beschreiben Sie diese." placeholder="Beschreibung" value={this.state.has_release_plan} value2={this.state.release_plan} slot='has_release_plan' slot2='release_plan' update={this.update} />
         <ConfirmedText heading="Sind Vorbereitungen für eine Installation notwendig?" placeholder="Beschreibung" value={this.state.is_preparation_needed} value2={this.state.preparation_needed} slot='is_preparation_needed' slot2='preparation_needed' update={this.update} />
         <ConfirmedText heading="Gibt es Empfehlungen oder Erfahrungswerte zu Ihrer Software?" placeholder="Referenzen" value={this.state.has_customer_reference} value2={this.state.customer_reference} slot='has_customer_reference' slot2='customer_reference' update={this.update} />
         <ConfirmedText heading="Wird die Software schon erfolgreich eingesetzt?" placeholder="erfolgreich eingesetzt" value={this.state.successful_deployment} value2={this.state.successful_deployment_description} slot='successful_deployment' slot2='successful_deployment_description' update={this.update} />
         <TextField heading="Welche sind die Einsatzbereiche Ihrer Software?" placeholder="Einsatzbereiche" maxLength='600' value={this.state.clinic_desc} slot='clinic_desc' update={this.update} />
         <IntegerField heading="Wieviele Nutzerinnen und Nutzer hat Ihre Software?" maxLength='20' value={this.state.user_number} placeholder="Nutzer Anzahl" slot='user_number' update={this.update} />
         <IntegerField heading="Wieviele davon sind Kliniken?" maxLength='20' value={this.state.clinic_number} placeholder="Anzahl der Kliniken" slot='clinic_number' update={this.update} />
         <ComplexityRate heading="Schätzen Sie: Wie komplex ist Ihre Software für Anwender?" subheading="" complexityRate={complexityRate} obligatory={false} value={this.state.complexity_rate} slot='complexity_rate' update={this.update} />
         <ResearchSoftwareMinimalDatePicker heading="Seit wann ist Ihre Software in Nutzung?" value={this.state.date} slot='date' update={this.update}/>

         <ComplexityRate heading="Wie schätzen Sie die mittlere Zufriedenheit der Nutzer(-innen) Ihrer Software ein?" complexityRate={satisfactionRate} obligatory={false} value={this.state.satisfaction_rate} slot='satisfaction_rate' update={this.update} />
         <TextField heading="Eine negative Zufriedenheit der Nutzer(-innen) kann begründet sein. Hier die Möglichkeit für eine Erklärung." maxLength='600' value={this.state.rating_desc} slot='rating_desc' update={this.update} />
         <MultipleFileUpload heading="Hier haben Sie die Möglichkeit, Ihr Produkt als eine Datei hochzuladen." value={this.state.product_files} slot="product_files" update={this.update}  />
         <CheckBox obligatory={true} heading="* Erklärung" content="Ich erkläre hiermit, dass die angebotene Software entweder meiner Institution oder mir selbst gehört oder mir der Verkauf in der angebotenen Version gestattet worden ist." value={this.state.agreement} slot='agreement' update={this.update} />
         <AGBCheckBox obligatory={true} value={this.state.agb_agreement} slot='agb_agreement'  agbUrl="/ueberlassungsvereinbarung.pdf"
         content1="Ich habe die " fileType="Überlassungsvereinbarung" content2=" gelesen und akzeptiere diese." update={this.update} />
       
         

         <div className="UpAndDownIcons">
      {/*   <div>
         <UpIcon />
         </div> 
         <div>
         <DownIcon />
         </div>*/}
         </div>
         </div>
         </div>
         <SubmitButton  history={this.props.history} onSubmit={this.save} />
         </div>
         </div>
         <Footer faqs={faqResearchsoftware}/>
         </div>
        }
      {!util.isNonCommercialUser() &&
       <div>Sie besitzen nicht genügend Rechte, um eine Software für Forschung und Lehre zu erstellen.</div>
      }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/researchsoftware.js